export type CommunicationMatchTimeframe = 'current_window' | 'previous' | 'future' | 'all';

export const communicationMatchTimeframeOptions: Array<{ value: CommunicationMatchTimeframe; label: string }> = [
  { value: 'current_window', label: 'Current Window' },
  { value: 'previous', label: 'Previous Matches' },
  { value: 'future', label: 'Future Matches' },
  { value: 'all', label: 'All Matches' },
];

function addCalendarDays(dateIso: string, days: number): string {
  const value = new Date(`${dateIso}T00:00:00`);
  value.setDate(value.getDate() + days);
  return value.toISOString().slice(0, 10);
}

export function communicationMatchDateBounds(timeframe: CommunicationMatchTimeframe, today: string): { from?: string; to?: string } {
  if (timeframe === 'current_window') return { from: addCalendarDays(today, -5), to: addCalendarDays(today, 14) };
  if (timeframe === 'previous') return { to: addCalendarDays(today, -1) };
  if (timeframe === 'future') return { from: today };
  return {};
}

export function matchIsInCommunicationTimeframe(matchDate: string, timeframe: CommunicationMatchTimeframe, today: string): boolean {
  const { from, to } = communicationMatchDateBounds(timeframe, today);
  return (!from || matchDate >= from) && (!to || matchDate <= to);
}
